import React, { useState, useEffect } from "react";
import { Box, Typography } from "@mui/material";
import { useDealership } from "@/contexts/DealershipContext";
import Image from "next/image";

const PrintFooter: React.FC = () => {
    const currentYear = new Date().getFullYear();
    const { participantInfo } = useDealership();
    const [isCadaDealership, setIsCadaDealership] = useState(false);

    // Determine if this is a truck dealership (ATD) or car dealership (NADA)
    const isTruckDealership = participantInfo?.car_truck === "T";

    useEffect(() => {
        if (typeof window !== "undefined") {
            setIsCadaDealership(window.location.hostname.includes("cada"));
        }
    }, []);
    const logoSrc = isCadaDealership
        ? "/MNP_logo.png"
        : isTruckDealership
          ? "/atd-logo.png"
          : "/nada-logo.png";
    const logoAlt = isCadaDealership ? "MNP Logo" : isTruckDealership ? "ATD Logo" : "NADA Logo";
    const copyrightText = isCadaDealership ? "CADA" : "NADA";

    return (
        <Box className="print-footer print-only">
            {/* Left side - ESIQ and NADA/ATD logos */}
            <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                <Image
                    src="/esiq-logo.png"
                    alt="ESIQ Logo"
                    width={60}
                    height={30}
                    style={{ objectFit: "contain" }}
                />
                {isCadaDealership ? (
                    <Image
                        src="/CADA_logo.jpg"
                        alt="CADA Logo"
                        width={80}
                        height={40}
                        style={{ objectFit: "contain" }}
                    />
                ) : null}
                <Image
                    src={logoSrc}
                    alt={logoAlt}
                    width={isCadaDealership ? 40 : 60}
                    height={isCadaDealership ? 20 : 30}
                    style={{ objectFit: "contain" }}
                />
            </Box>

            {/* Right side - Copyright text */}
            <Box sx={{ textAlign: "right" }}>
                <Typography variant="caption" sx={{ fontSize: "10px" }}>
                    © {copyrightText} 2012–{currentYear}. All rights reserved.
                </Typography>
            </Box>
        </Box>
    );
};

export default PrintFooter;
